export default {
  assignees: {},
  loggedInUserDetail: {},
};
